import React from 'react';
import ProviderDeviceChip from './ProviderDeviceChip';

interface Props {
  label: string;
  unit?: string;
  value: number | null | undefined;
  provider?: string;
  device?: string | null;
}

const MetricValue: React.FC<Props> = ({ label, unit, value, provider, device }) => {
  const formatted = value === null || value === undefined ? '—' : String(value);
  return (
    <div data-testid={`metric-${label}`} className="d-flex flex-column mb-3">
      <small className="text-muted">{label}</small>
      <span>
        <strong>{formatted}</strong>
        {unit && value !== null && value !== undefined ? <> {unit}</> : null}
        {provider ? (
          <span className="ms-2">
            <ProviderDeviceChip provider={provider} device={device} />
          </span>
        ) : null}
      </span>
    </div>
  );
};

export default MetricValue;
